(function () {
    var $body = $('body');

    var toggle = {
        $toggle: $('.facet:not(.displayAll)'),
        lessLabel: 'Less',
        moreLabel: 'More',
        init: function () {
            toggle.setLabels();
            toggle.on.build();
            toggle.control();
            toggle.additionalControls();
        },
        control: function () {
            $body.on('click', '.facet .show-more', function (e) {
                e.preventDefault();
                toggle.on.toggle($(this));
            });
            $body.find('.facet .dropdown__toggle').off();
            $body.on('click', '.facet .dropdown__toggle', function (e) {
                e.preventDefault();
                toggle.on.toggleFacet($(this));
            });
        },
        additionalControls: function () {},
        setLabels: function () {
            let $filters = $('#filter');
            if ($filters.length) {
                toggle.moreLabel = $filters.data('more-text') ? $filters.data('more-text') : toggle.moreLabel;
                toggle.lessLabel = $filters.data('less-text') ? $filters.data('less-text') : toggle.lessLabel;
            }
        },
        on: {
            build: function () {
                toggle.$toggle.each(function () {
                    var $target = $(this).find('ul.facet__list');
                    var $lis = $target.children('li');

                    var $select = $(this).find('.facet__select ');
                    var $options = $select.children('option');

                    var lisNum = $lis.length;
                    var optionsNum = $options.length;
                    var shownItems = $target.find('[name=facet-shown-items]').val() || 5;
                    var isToggle = lisNum > shownItems;

                    var moreCount = optionsNum + lisNum - shownItems;

                    if ($target.find('[name=facet-hidden-items]').length)
                        moreCount = $target.find('[name=facet-hidden-items]').val();
                    $target.closest('.facet').attr('data-more-count', moreCount);

                    if (isToggle) $target.after(toggle.get.showMore(moreCount));
                });
            },
            toggle: function (elem) {
                var $toggle = elem.closest('.facet');
                var $target = $toggle.find('ul.facet__list');

                $target.find('.js--toggle').slideToggle();
                $toggle.find('.facet__select--hidden').toggle();

                elem.toggleClass('js--open');
                if (elem.hasClass('js--open')) {
                    elem.html(toggle.lessLabel + '<i class="icon-section_arrow_u" aria-hidden="true"></i>');
                    elem.closest('.accordion__content').find('li.js--toggle')[0].firstElementChild.focus();
                    elem.attr('aria-expanded', true);
                } else {
                    elem.html(
                        toggle.moreLabel +
                            ' <span  class="more-count">(' +
                            $toggle.data('more-count') +
                            ')</span> <i class="icon-section_arrow_d" aria-hidden="true"></i>'
                    );
                    elem.closest('.accordion__content').find('li:first-child a').blur();
                    elem.attr('aria-expanded', false);
                }
            },
            toggleFacet: function (elem) {
                var $toggle = elem.closest('li');
                var $target = $toggle.children('ul.facet-dropdown__menu');

                $target.slideToggle();
                elem.toggleClass('js--open');
                elem.find('i').toggleClass('icon-add_box icon-squared-minus');

                if (elem.hasClass('js--open')) {
                    $target.attr('aria-hidden', false);
                } else {
                    $target.attr('aria-hidden', true);
                }
            },
        },
        get: {
            /**
             * gets the show more/less link.
             * was added to make it easier for engineer to override it's value
             *
             * @param count
             * @returns {string}
             */
            showMore(count) {
                return `<a href="#" class="show-more" aria-expanded="false" rel="nofollow"> ${toggle.moreLabel} <span class="more-count">(${count})</span> <i class="icon-section_arrow_d" aria-hidden="true"></i></a>`;
            },
        },
    };

    UX.toggle = toggle; // add to global namespace
})();
